import React from "react";
import './loader.css';

const Loader = () => {
  return (
    <div style={{
      width: "100vw",
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "fixed",
      left: "0",
      top: "0",
      background: '#00000080',
      zIndex: '9999'
    }}>
      <span style={{
        width: "48px",
        height: "48px",
        border: "5px solid #FFF",
        borderBottomColor: "transparent",
        borderRadius: "50%",
        display: "inline-block",
        boxSizing: "border-box",
        animation: "rotation 1s linear infinite",
      }} className="loader"></span>
    </div>
  );
};

export default Loader;
